import React from 'react';
import classnames from 'classnames';
import { createUseStyles, useTheme } from 'react-jss';
import { Colors, Theme } from '@app/theme';

const useStyles = createUseStyles<
  string,
  { bgColor?: Colors; color?: Colors },
  Theme
>((theme: Theme) => ({
  container: (props) => ({
    height: theme.height.tiny,
    minWidth: theme.height.tiny,
    padding: 6,
    borderRadius: theme.height.tiny / 2,
    backgroundColor: props.bgColor || theme.colors.yellowMuted,

    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  }),
  icon: (props) => ({
    color: props.color || theme.colors.inkPrimary,
    fontSize: theme.iconSize.regular,
    marginRight: 6,
    '&:last-child': {
      marginRight: 0,
    },
  }),
}));

interface Props {
  icon: string;
  bgColor?: Colors;
  color?: Colors;
  className?: string;
}

export const RoundBgIcon = ({ icon, className, bgColor, color }: Props) => {
  const theme: Theme = useTheme();
  const classes = useStyles({ theme, color, bgColor });
  return (
    <div className={classnames(classes.container, className)}>
      <i className={classnames(icon, classes.icon)} />
    </div>
  );
};
